import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { IagPortalLoggingInPage } from 'src/app/model/page/group/iag-portal/iag-portal-logging-in-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-iag-portal-logging-in-page',
  templateUrl: './iag-portal-logging-in-page.component.html',
  styleUrls: ['./iag-portal-logging-in-page.component.scss']
})
export class IagPortalLoggingInPageComponent implements OnInit {
  iagPortalLoggingInPage: IagPortalLoggingInPage = {} as IagPortalLoggingInPage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'iag-portal-logging') {
        this.iagPortalLoggingInPage.htmlTitle = title.htmlTitle;
      }
    });
    this.iagPortalLoggingInPage.sections = [];
    this.iagPortalLoggingInPage.loggingInCards = [];

    const query = { 'fields.title': 'Logging In' };
    this.contentfulService.getPageContentResponse(query).then((iagPortalLoggingInPageEntries) => {
      this.mapBanner(iagPortalLoggingInPageEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.iagPortalLoggingInPage.banner);
      this.mapPageInfo(iagPortalLoggingInPageEntries.items);
      this.mapSections(iagPortalLoggingInPageEntries.includes.Entry);
      this.mapCards(iagPortalLoggingInPageEntries.includes.Entry);
    });
  }

  private mapBanner(iagPortalLoggingInPageEntries: Entry<any>[]) {
    iagPortalLoggingInPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
    let video: any = entry.fields['video'] as string;
    this.iagPortalLoggingInPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url,
      video: video?.fields?.file?.url
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.iagPortalLoggingInPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.iagPortalLoggingInPage.banner.url = entry.fields?.url;
      this.iagPortalLoggingInPage.banner.editorEmail = editorDetails?.pop();
      this.iagPortalLoggingInPage.banner.editorShortName = editorDetails?.pop();
      this.iagPortalLoggingInPage.banner.editorFullName = editorDetails?.pop();
      this.iagPortalLoggingInPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapSections(iagPortalLoggingInPageEntries: Entry<any>[]) {
    iagPortalLoggingInPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.iagPortalLoggingInPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;
    this.iagPortalLoggingInPage.sections.push({
      title: title.split('#').pop(),
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }

  private mapCards(iagPortalLoggingInPageEntries: any[]) {
    iagPortalLoggingInPageEntries
      .filter((entry) => ModelValidator.isCard(entry))
      .forEach((entry) => {
        this.mapEntryToLoggingInCard(entry);
      });
  }

  private mapEntryToLoggingInCard(entry: Entry<any>) {
    // console.log(entry);
    this.iagPortalLoggingInPage.loggingInCards.push({
      title: entry.fields['title'] as string,
      order: entry.fields['order'] as number,
      url: entry.fields['url'] as string,
      buttonText: entry.fields['buttonText'] as string,
      buttonUrl: entry.fields['buttonUrl'] as string,
      headText: entry.fields['headText'] as string,
      shortBody: entry.fields['shortBody'] as string
    });
    // console.log('logging', this.iagPortalLoggingInPage.loggingInCards);
    this.iagPortalLoggingInPage.loggingInCards.sort((a, b) => a.order - b.order);
  }
}
